import { useState } from "react";
import { Lightbulb, ChevronDown } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { guideFor, GENERAL_TIPS } from "@/lib/learn";

export const PrepTips = ({ types }) => {
  const { t } = useApp();
  const [open, setOpen] = useState(true);
  const list = guideFor(types);
  return (
    <div className="rounded-2xl border border-[#2E9E6B]/40 bg-[#2E9E6B]/5 p-4" data-testid="prep-tips">
      <button onClick={() => setOpen(!open)} className="flex w-full items-center justify-between font-bold text-[#0D3B2B]" data-testid="prep-tips-toggle">
        <span className="flex items-center gap-2"><Lightbulb className="h-5 w-5 text-[#E05C3A]" />{t("How to prepare for your pickup")}</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-3 space-y-3 text-sm text-[#0D3B2B]">
          {list.map((g) => (
            <div key={g.key}><p className="font-semibold">{t(g.title)}</p>
              <ul className="ml-4 list-disc text-[#4A6358]">{g.tips.map((x) => <li key={x}>{t(x)}</li>)}</ul></div>
          ))}
          <ul className="ml-4 list-disc text-[#4A6358]">{GENERAL_TIPS.slice(0, 2).map((x) => <li key={x}>{t(x)}</li>)}</ul>
        </div>
      )}
    </div>
  );
};

const REPEATS = [["", "Just once"], ["weekly", "Every week"], ["biweekly", "Every 2 weeks"], ["monthly", "Every month"]];

export const RepeatPicker = ({ value = "", onChange, testid = "repeat-picker" }) => {
  const { t } = useApp();
  return (
    <div className="space-y-2" data-testid={testid}>
      <p className="text-sm font-semibold text-[#0D3B2B]">{t("Repeat this pickup?")}</p>
      <div className="grid grid-cols-2 gap-2">
        {REPEATS.map(([v, l]) => (
          <button key={v || "once"} type="button" onClick={() => onChange(v)} data-testid={`${testid}-${v || "once"}`}
            className={`h-11 rounded-xl border-2 text-sm font-semibold ${value === v ? "border-[#2E9E6B] bg-[#2E9E6B]/10 text-[#0D3B2B]" : "border-[#D2E0D8] text-[#4A6358]"}`}>{t(l)}</button>
        ))}
      </div>
      {value && <p className="text-xs text-[#4A6358]">{t("After each pickup is completed, the next one is booked automatically at the same time. You can stop it anytime.")}</p>}
    </div>
  );
};
